import React, { useContext, useEffect, useState } from "react";
import {
  Footer as FooterLibrary,
  ProgramInfoFooter,
} from "carynhealth-component-library";
import { footerProps, AiChatIcon } from "./data";
import { AuthContext } from "../../context/AuthenticateContext";
import { useNavigate, useLocation } from "react-router-dom";
import { getRoutePaths } from "../../config/constants/routePaths";
import CarynIcon from "../../assests/images/uhf/carynIcon.jpg";
import { Fab, useMediaQuery, useTheme } from "@mui/material";
import ForumIcon from "@mui/icons-material/Forum";
import config from "../../config/constants/config";
import messages from "../../config/constants/messages";
import { ReturenTransString } from "../../ReturenTransString";

const Footer = () => {
  const auth = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();
  const [myFooterProps, setMyFooterProps] = useState<any>({});
  const [AiIcon] = useState<any>(AiChatIcon);
  const theme = useTheme();
  const showText = useMediaQuery(theme.breakpoints.down("md"));
  useEffect(() => {
    setFooterData();
  }, [auth]);

  const setFooterData = () => {
    let footerData: any = footerProps(
      auth.authenticatedInfo.isAuthenticated,
      auth.authenticatedInfo.throughEmail
    );
    if (auth.authenticatedInfo.isAuthenticated) {
      footerData.bottomNavgation.bottomNavCallBack = myCallBack;
    }
    setMyFooterProps(footerData);
  };

  const myCallBack = (data: any) => {
    switch (data) {
      case 0:
        navigate(getRoutePaths.dashboard);
        break;
      case 1:
        navigate(getRoutePaths.documents);
        break;
      case 2:
        navigate(getRoutePaths.myNeeds);
        break;
      default:
        navigate(getRoutePaths.dashboard);
        break;
    }
  };
  if (
    (location.pathname === getRoutePaths.aiChat ||
      !auth.authenticatedInfo.isAuthenticated) &&
    showText
  )
    return <></>;

  return (
    <>
      {AiIcon && location.pathname !== getRoutePaths.login && showText && (
        <div
          id="AI-chat_icon"
          style={{
            position: "fixed",
            right: 0,
            left: "80%",
            bottom: 50,
          }}
        >
          <img
            src={CarynIcon}
            width="51px"
            onClick={() => navigate(getRoutePaths.aiChat)}
          />
        </div>
      )}
      {showText && (
        <ProgramInfoFooter
          label={""}
          rightSectionText={
            config.APP_NAME === config.BRAND_NETWELL
              ? messages.netwell.NEEDHELP_MSG
             : config.APP_NAME === config.BRAND_CURAMLIFE ?
             ReturenTransString('NEEDHELP_MSG_CURAMLIFE')
              : ReturenTransString('NEEDHELP_MSG')
          }
          showChatIcon={() =>
            config.APP_NAME === config.BRAND_NETWELL ? (
              <></>
            ) : (
              <div style={{ marginLeft: 12 }}>
                <Fab
                  aria-label="add"
                  style={{ zIndex: 0 }}
                  sx={{ background: "#fb6647", color: "#fff" }}
                >
                  <ForumIcon sx={{ color: "#fff" }} />
                </Fab>
              </div>
            )
          }
        />
      )}
      <FooterLibrary {...myFooterProps} />
    </>
  );
};

export default Footer;
